import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import RollOverInitial from './pages/initial';
import RollOverSelection from './pages/selection';
import HelpModal from './modals/help';
import RollOverError from './modals/error';
import RollOverUpload from './pages/upload';
import RollOverConfirmation from './modals/confirmation';
import RollOverResult from './modals/results';
import RollOverSummary from './pages/summary';
import css from './index.scss';

const RollOver = (props) => {
    const { helpModal,
        selectionPage,
        uploadPage,
        initialPage,
        summaryPage } = props;

    let component;

    if (selectionPage) {
        component = (<RollOverSelection {...props} />);
    } else if (initialPage) {
        component = (<RollOverInitial {...props} />);
    } else if (uploadPage) {
        component = (<RollOverUpload {...props} />);
    } else if (summaryPage) {
        component = (<RollOverSummary {...props} />);
    }

    return (<div className={css.rollOverContainer}>
        {component}
        <HelpModal isActive={helpModal} {...props} />
        <RollOverError {...props} />
        <RollOverConfirmation {...props} />
        <RollOverResult {...props} />
    </div>);
};

RollOver.propTypes = {
    helpModal: PropTypes.bool,
    selectionPage: PropTypes.bool,
    uploadPage: PropTypes.bool,
    initialPage: PropTypes.bool,
    showUploadModal: PropTypes.bool,
    message: PropTypes.object,
    closeModal: PropTypes.func,
    closeUploadErrorModal: PropTypes.func,
    summaryPage: PropTypes.bool
};

export default styleable(css)(RollOver);



// WEBPACK FOOTER //
// ./app/components/roll-over/index.js